<template>
  <q-select :outlined="!borderless" :borderless v-bind="$attrs" ref="selectRef">
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </q-select>
</template>

<script setup>
import { useTemplateRef } from "vue";

defineProps({
  borderless: {
    type: Boolean,
    default: false,
  },
});

// Refs
const selectRef = useTemplateRef("selectRef");

// Expose
defineExpose({
  selectRef,
});
</script>

<style lang="scss">
label.q-field {
  .q-field__control-container input[required] + .q-field__label:after {
    content: " *";
  }
}
</style>
